import React from "react";
import { useFormikContext } from "formik";
import { withRouter } from "react-router-dom";
import { scrollToError } from "../../../../create-app/utils/scroll-to-error";
import styles from "../../style.module.scss";
import Button from "../../../../../components/new-button";

const Footer = ({ dataLoading, history }) => {
  const { values, handleSubmit, isSubmitting, validateForm, setTouched } =
    useFormikContext();

  const handleSaveClick = async () => {
    const validationErrors = await validateForm();
    const hasErrors =
      validationErrors && Object.keys(validationErrors).length > 0;

    setTouched(
      Object.keys(values).reduce((acc, key) => {
        acc[key] = true;
        return acc;
      }, {}),
    );

    if (hasErrors) {
      scrollToError(validationErrors);
      return;
    }

    handleSubmit();
  };

  return (
    <div className={styles.buttons}>
      <Button
        size="large"
        variant="ghost"
        onClick={() => history.push("/v2/templates")}
        disabled={isSubmitting || dataLoading}
      >
        Cancel
      </Button>
      <Button
        size="large"
        variant="primary"
        onClick={handleSaveClick}
        disabled={isSubmitting || dataLoading}
      >
        {isSubmitting ? "Saving..." : "Save"}
      </Button>
    </div>
  );
};

export default withRouter(Footer);
